export const SET_FILTERS = '@dashboardRevamp/newInventory/SET_FILTERS';
